import { m8API } from 'services/production/m8';
import { PartnerClientsTableGroup } from 'types/partnerClientsTable';
import { GetPartnerPaidClientTableGroupsService } from 'types/services';
import { normalizeM8PartnerClientsOnMonthDTO } from '../utils/normalizeM8PartnerClientsOnMonthDTO';

export const getPartnerPaidClientTableGroupsService: GetPartnerPaidClientTableGroupsService = async () => {
  const allGroups: PartnerClientsTableGroup[] = [];

  const m8PartnerClientsOnMonth = await m8API.partner.getPaidClientsForCurrentMonth();

  if (m8PartnerClientsOnMonth) {
    const currentMonthGroup = normalizeM8PartnerClientsOnMonthDTO(
      m8PartnerClientsOnMonth
    ).toPartnerClientsTableGroup();

    allGroups.push(currentMonthGroup);
  }

  for (let page = 0; page >= 0; page += 1) {
    const m8PartnerClientsOnMonthDTOs = await m8API.partner.getPaidClientsForPrevMonth(
      { page }
    );

    if (m8PartnerClientsOnMonthDTOs.length > 0) {
      m8PartnerClientsOnMonthDTOs.forEach((m8PartnerClientsOnMonthDTO) => {
        const partnerClientsTableGroup = normalizeM8PartnerClientsOnMonthDTO(
          m8PartnerClientsOnMonthDTO
        ).toPartnerClientsTableGroup();

        allGroups.push(partnerClientsTableGroup);
      });
    } else {
      break;
    }
  }

  return allGroups.filter((group) => group.items.length > 0);
};
